import { render } from "./Resources.vue?vue&type=template&id=0ee0579d&scoped=true&ts=true"
import script from "./Resources.vue?vue&type=script&lang=ts"
export * from "./Resources.vue?vue&type=script&lang=ts"

import "./Resources.vue?vue&type=style&index=0&id=0ee0579d&scoped=true&lang=css"

import exportComponent from "/builds/otto-tech/otto-financas-site/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ee0579d"]])

export default __exports__